<template>
  <div class="container" >
    <p class="title">Proposal Details</p>

   <div>
     <p class="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
     <p class="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
     <p class="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
   </div>

    <divider></divider>

    <div class="comments-container">
      <div class="top-section">
        <p>Sort Comments by: Most Recent</p>
        <p>54 comments</p>
      </div>
      <comment></comment>
      <comment></comment>

      <p class="see-more title">See more comments</p>

      <div>
        <p class="title leave-comment-text">Leave a comment</p>
        <div class="comment-input-container">
          <text-area rows="2" v-model="comment" />
          <div class="button-container">
            <button class="button is-primary">SEND</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Divider from '../../general/divider.vue'
import Comment from './comment.vue'
import TextArea from '../../general/text-area.vue'

export default {
  name: 'ProposalDetail',
  components: {
    Divider, Comment, TextArea
  },
  data () {
    return {
      comment: ''
    }
  },
  computed: {
  },
  methods: {
  },
  async mounted () {
  },
  beforeDestroy () {
  }
}
</script>

<style lang="scss" scoped>
.container{
  padding: 32px 24px;
  border: 0.5px solid rgba(0, 0, 0, 0.15);
  background: #F9F9F9;
  margin-top: 24px;
}

.title{
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 14px;
}

@media (max-width: 760px) {
  .title{
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 12px;
  }
}

.text{
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 14px;
}

.top-section{
display: flex;
  justify-content: space-between;
}

.see-more{
  color: #31E5FF;
  margin-top: 24px;
  cursor: pointer;
}

.leave-comment-text{
  margin-top: 20px;
}
.button-container{
  display: flex;
  justify-content: end;
}
</style>



// WEBPACK FOOTER //
// src/components/dao-community/proposal/proposal-detail.vue